import { Shield, Landmark, Headphones } from "lucide-react";
import Reveal from "../Reveal";

const badges = [
  {
    icon: (
      <div className="relative">
        <Landmark size={32} className="text-cm-blue" strokeWidth={1.5} />
      </div>
    ),
    label: "F.I.U. Compliant",
    desc: "Registered with regulators",
  },
  {
    icon: <MoneyBag />,
    label: "Insured Funds",
    desc: "1:1 reserve transparency",
  },
  {
    icon: <Headphones size={32} className="text-cm-blue" strokeWidth={1.6} />,
    label: "24/7 Support",
    desc: "Always-on assistance",
  },
  {
    icon: <ISOBadge />,
    label: "ISO/IEC 27001:2022",
    desc: "Security certified",
  },
];

function MoneyBag() {
  return (
    <svg viewBox="0 0 48 48" width="36" height="36" fill="none" aria-hidden>
      <path d="M16 12 L32 12 L34 8 L14 8 Z" fill="#C8A86B" stroke="#8B6B3A" strokeWidth="1" />
      <path
        d="M14 14 C 10 20, 8 30, 10 36 C 12 42, 36 42, 38 36 C 40 30, 38 20, 34 14 Z"
        fill="#E8C98E"
        stroke="#8B6B3A"
        strokeWidth="1"
      />
      <text x="24" y="32" textAnchor="middle" fontSize="14" fontWeight="700" fill="#5A4220">
        $
      </text>
    </svg>
  );
}

function ISOBadge() {
  return (
    <svg viewBox="0 0 48 48" width="36" height="36" fill="none" aria-hidden>
      <rect x="6" y="6" width="36" height="36" fill="#fff" stroke="#022CED" strokeWidth="1.5" />
      <text x="24" y="30" textAnchor="middle" fontSize="11" fontWeight="800" fill="#022CED">
        ISO
      </text>
    </svg>
  );
}

export default function ComplianceBadges() {
  return (
    <section className="bg-cm-surface border-b border-[var(--cm-border)] py-8 lg:py-10" data-testid="compliance-badges">
      <div className="cm-container">
        <div className="flex items-center gap-3 mb-6 lg:mb-8">
          <div className="w-10 h-10 rounded-full bg-cm-blue/10 grid place-items-center shrink-0">
            <Shield size={20} className="text-cm-blue" />
          </div>
          <div>
            <p className="text-[15px] font-bold text-cm-navy">Built for regulated markets</p>
            <p className="text-[12px] text-cm-grey mt-0.5">Security, reserves, and support you can verify</p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {badges.map((b, i) => (
            <Reveal
              key={b.label}
              variant="fade-up"
              delay={i * 70}
              className="cm-landing-feature-card flex items-start gap-4 p-5 lg:p-6"
            >
              <div className="w-12 h-12 rounded-xl bg-cm-lavender grid place-items-center shrink-0">
                {b.icon}
              </div>
              <div>
                <div className="text-[14px] font-bold text-cm-navy">{b.label}</div>
                <div className="text-[12px] text-cm-grey mt-1">{b.desc}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
